import type { SyntheticEvent } from 'react'
import React, { useState } from 'react'

import { Box, Tab, Tabs } from '@mui/material'
import { useAuthContext } from 'AuthProvider'
import { CustomTabPanel, FileUpload } from 'components/commonparts'
import OptimizeRequest from 'components/commonparts/OptimizeRequest/OptimizeRequest'
import { StockDetail } from 'components/parts'
import { UploadRecordTab, useUploadRecordTabStore } from 'store/uploadRecordTabStore'

import type { ResponseResult } from 'api-client'

function UploadRecord() {
  const uploadRecordTabState = useUploadRecordTabStore((state) => state.uploadRecordTabState)
  const setUploadRecordTabsState = useUploadRecordTabStore((state) => state.setUploadRecordTabsState)
  const { loginUserInfo } = useAuthContext()

  const [value, setValue] = useState(uploadRecordTabState)
  
  // Get trCompanyId from user info
  const trCompanyId = loginUserInfo?.companyId || 1
  
  // StockDetail states
  const [resultMessage, setResultMessage] = useState<ResponseResult | undefined>()
  const [isCsvLoading, setIsCsvLoading] = useState(false)
  const [isExcelLoading, setIsExcelLoading] = useState(false)
  const [isUploadLoading, setIsUploadLoading] = useState(false)

  const handleChange = (_event: SyntheticEvent, newValue: (typeof UploadRecordTab)[keyof typeof UploadRecordTab]) => {
    setValue(newValue)
    setUploadRecordTabsState(newValue)
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  // StockDetail handlers
  const handleStockFileUploadEnd = () => {
    // eslint-disable-next-line no-console
    console.log('Stock file upload completed')
  }

  const handleCsvDownload = async () => {
    setIsCsvLoading(true)
    try {
      // TODO: Implement CSV download API call
      // eslint-disable-next-line no-console
      console.log('CSV download triggered')
    } finally {
      setIsCsvLoading(false)
    }
  }

  const handleExcelDownload = async () => {
    setIsExcelLoading(true)
    try {
      // TODO: Implement Excel download API call
      // eslint-disable-next-line no-console
      console.log('Excel download triggered')
    } finally {
      setIsExcelLoading(false)
    }
  }

  return (
    <Box>
      <Box sx={{ marginBottom: 1, borderBottom: 1 }}>
        <Tabs value={value} onChange={handleChange} aria-label="tabs">
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Tab value={UploadRecordTab.Order} label="発注" {...a11yProps(0)} />
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Tab value={UploadRecordTab.Ship} label="受注 (出荷予測のみ利用の場合）" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={UploadRecordTab.Order}>
        <FileUpload dataType="TOrderArrival" title="発注入荷実績" isDownload={false} />
        <FileUpload dataType="TStock" title="在庫実績" isDownload={false} />
        <FileUpload dataType="TShippingOrder" title="受注出荷実績" isDownload={false} />
        <OptimizeRequest adhockType='exec_optimize'/>
        <OptimizeRequest adhockType='exec_predict_optimize'/>
        <StockDetail
          trCompanyId={trCompanyId}
          resultMessage={resultMessage}
          setResultMessage={setResultMessage}
          onStockFileUploadEnd={handleStockFileUploadEnd}
          onCsvDownload={handleCsvDownload}
          onExcelDownload={handleExcelDownload}
          isCsvLoading={isCsvLoading}
          isExcelLoading={isExcelLoading}
          isUploadLoading={isUploadLoading}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={UploadRecordTab.Ship}>
        <FileUpload dataType="TShippingOrder" title="受注出荷実績" isDownload={false} />
      </CustomTabPanel>
    </Box>
  )
}

export default UploadRecord
